import { render, staticRenderFns } from "./home_bak.vue?vue&type=template&id=1bc0a2a8&"
import script from "./home_bak.vue?vue&type=script&lang=js&"
export * from "./home_bak.vue?vue&type=script&lang=js&"
import style0 from "./home_bak.vue?vue&type=style&index=0&id=1bc0a2a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports